__turbopack_context__.v({
  "audience": "offer-message-module__xsSZVG__audience",
  "badge": "offer-message-module__xsSZVG__badge",
  "compact": "offer-message-module__xsSZVG__compact",
  "heading": "offer-message-module__xsSZVG__heading",
  "message": "offer-message-module__xsSZVG__message",
});
